module.exports = __webpack_public_path__ + "assets/freshworks.eda52891.png";